import { useCallback } from "react";
import { useWeb3React, UnsupportedChainIdError } from "@web3-react/core";
// import { useToast } from "../state/hooks";
import { connectorsByName } from "../utils/web3React";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";

const useAuth = () => {
  // const { toastError } = useToast();

  // const TomiPayBol = localStorage.getItem('IsTomipay')

  const login = async (connectorID) => {
    const connector = connectorsByName[connectorID];
    if (connector) {
      if (connectorID === 'injected') {
        await connector.activate(42161)
      } else {
        await connector.activate()
        // if (TomiPayBol == 'false') {
        //   console.log("here i trust", connector)
        //   await connector.activate()
        // } else {
        //   console.log("here i tomi ", connector)
        //   setTimeout(async () => {
        //     let ab = await connector?.provider?.signer?.uri
        //     console.log("providerNullproviderNullproviderNull", ab)
        //     // alert(ab)
        //     if (ab == undefined) {
        //       localStorage.setItem('provider', 'true');
        //     }
        //     else {
        //       localStorage.setItem('provider', 'false');
        //     }
        //     // alert(ab)
        //     window["ReactNativeWebView"] && window["ReactNativeWebView"].postMessage(ab);
        //   }, 3000)
      }
    } else {
      console.log("Connector not found");
    }
  }



  const logout = async (connectorID) => {
    const connector = connectorsByName[connectorID];
    if (connector) {
      if (connector?.deactivate) {

        const response = await connector.deactivate()
      } else {
        await connector.resetState();
      }
      // await connector.deactivate()
    } else {
      // toastError("Can't find connector", "The connector config is wrong");

    }
  };

  return { login, logout };
};

export default useAuth;